var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-dialog");
/**
 * This component is used to render the main content within a dialog. There are
 * really only benefits when using the component alongside the `DialogHeader`
 * and/or `DialogFooter` since it is set up so only the content will scroll
 * while the header and footer will be "fixed".
 */
export var DialogContent = forwardRef(function DialogContent(_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.disablePadding, disablePadding = _b === void 0 ? false : _b, props = __rest(_a, ["children", "className", "disablePadding"]);
    return (_jsx("div", __assign({}, props, { ref: ref, className: cn(block("content", {
            padded: !disablePadding,
        }), className) }, { children: children })));
});
//# sourceMappingURL=DialogContent.js.map